/* globals $ */
import { registerClass } from 'libs/ComponentLoader'

import './styles.scss'

class Breadcrumbs {
  constructor (element) {
    this.$el = $(element)
  }
}

registerClass('Breadcrumbs', Breadcrumbs)
